import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(showGlobalSearchResults),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchGlobalSearchResults);

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Eric Chu, Akhil Mara

 Description:
 */

/*_*/
import { put, call, select, takeEvery } from 'redux-saga/effects';
import { workingStart, workingEnd } from 'wfui-digital-core/es/actions';
import getJSON from '../../../network/get-json';
import postForm from '../../../network/post-form';
import logger from '../../../logger/logger';
import getString from '../../../strings/get-string';
import { getGlobalSearchValue, getGlobalSearchUrl, getGlobalSearchMode } from '../../selectors';
import NavigationItemRecord from '../../../records/NavigationItemRecord';
import { showStopMessage } from '../../stop-message/actions';
import { setUtagSearchTerm } from '../../../tealium/tealium';
import * as navigation from '../../navigation/actions';
import * as actions from '../actions';

var getNavigationItem = function getNavigationItem(_ref) {
  var url = _ref.url,
      displayType = _ref.displayType;
  return new NavigationItemRecord({
    navigationUrl: url,
    displayType: displayType
  });
};

function showGlobalSearchResults() {
  var input, url, mode, params, results, searchResultsBean, ctaUrl, searchResultsTOsList, payload, navigationData, navigationItem, FailureMessageBean, globalMessages, message, _FailureMessageBean, _globalMessages, _message;

  return regeneratorRuntime.wrap(function showGlobalSearchResults$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return select(getGlobalSearchValue);

        case 3:
          input = _context.sent;
          _context.next = 6;
          return select(getGlobalSearchUrl);

        case 6:
          url = _context.sent;
          _context.next = 9;
          return select(getGlobalSearchMode);

        case 9:
          mode = _context.sent;
          params = {
            input: input,
            mode: mode
          }; // fetch search results

          _context.next = 13;
          return call(getJSON, {
            url: url,
            includeRootContext: false,
            params: params
          });

        case 13:
          results = _context.sent;
          searchResultsBean = results.searchResultsBean || results; // set the search term in utag_data

          setUtagSearchTerm(input); // navigate if requested

          if (!(searchResultsBean && searchResultsBean.directNavigation)) {
            _context.next = 40;
            break;
          }

          _context.prev = 17;
          _context.next = 20;
          return put(workingStart());

        case 20:
          ctaUrl = searchResultsBean.ctaUrl, searchResultsTOsList = searchResultsBean.searchResultsTOsList;
          payload = {
            identifier: searchResultsTOsList[0].identifier || '',
            wwwUrl: searchResultsTOsList[0].wwwUrl || ''
          };
          _context.next = 24;
          return call(postForm, {
            url: ctaUrl,
            includeRootContext: false,
            data: payload
          });

        case 24:
          navigationData = _context.sent;
          navigationItem = getNavigationItem(navigationData.linkNavigationViewBean);
          _context.next = 28;
          return put(navigation.requestNavigation(navigationItem));

        case 28:
          _context.next = 38;
          break;

        case 30:
          _context.prev = 30;
          _context.t0 = _context["catch"](17);
          logger.error('Failed to directly navigate to page', _context.t0.FailureMessageBean);
          FailureMessageBean = _context.t0.FailureMessageBean || {};
          globalMessages = FailureMessageBean.globalMessages || [{}];
          message = globalMessages[0].message || getString('globalSearch.system.unavailable');
          _context.next = 38;
          return put(showStopMessage(message));

        case 38:
          _context.next = 43;
          break;

        case 40:
          if (!searchResultsBean) {
            _context.next = 43;
            break;
          }

          _context.next = 43;
          return put(actions.setGlobalSearchResults(searchResultsBean));

        case 43:
          _context.next = 53;
          break;

        case 45:
          _context.prev = 45;
          _context.t1 = _context["catch"](0);
          logger.error('Failed to retrieve search results', _context.t1.FailureMessageBean);
          _FailureMessageBean = _context.t1.FailureMessageBean || {};
          _globalMessages = _FailureMessageBean.globalMessages || [{}];
          _message = _globalMessages[0].message || getString('globalSearch.system.unavailable');
          _context.next = 53;
          return put(showStopMessage(_message));

        case 53:
          _context.prev = 53;
          _context.next = 56;
          return put(workingEnd());

        case 56:
          return _context.finish(53);

        case 57:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 45, 53, 57], [17, 30]]);
}

function fetchGlobalSearchResults() {
  return regeneratorRuntime.wrap(function fetchGlobalSearchResults$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(actions.GLOBAL_SEARCH_FETCH_RESULTS, showGlobalSearchResults);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

export default fetchGlobalSearchResults;